enum ProfileRoutesEnum {
  ProfileDetails = '/profile/details',
  ProfileExit = '/profile/exit',
}

export default ProfileRoutesEnum;
